import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { updateRefStatusRoutine } from '../../routines';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import { IReferencesStatus } from '../../../../common/models/reference/IReferenceStatus';
import { SurveyStatus } from '../../../../common/enums/SurveyStatus';
import RegularButton from '../../../../components/RegularButton';
import ModalWindow from '../../../../components/ModalWindow';
import styles from './styles.module.scss';

interface IProps {
  ids: string[];
  onHide: IBindingAction;
  updateRefStatus: IBindingCallback1<IReferencesStatus>;
}

const ReviewReferencesModal: FunctionComponent<IProps> = ({
  ids,
  onHide,
  updateRefStatus
}) => {
  const review = (status: SurveyStatus) => {
    updateRefStatus({ status, ids });
    onHide();
  };

  return (
    <ModalWindow
      isShown={Boolean(ids.length)}
      onHide={onHide}
      contentClassName="small-modal modal-wrapper"
    >
      <div className={styles.background}>
        <div className="custom-modal-header">
          <FormattedMessage
            id="contactProfile.reviewRefTitle"
            defaultMessage="Automate survey or manual contact?"
          />
        </div>
        <div className={styles.modalBody}>
          <FormattedMessage
            id="contactProfile.reviewRefDescription"
            values={{ breakingLine: <br /> }}
            defaultMessage={`Automate / send this reference a Kodiak survey?
            {breakingLine}{breakingLine}
            Or do you plan to contact this reference directly and conduct the reference check via phone?`}
          />
        </div>
        <div className="modal-footer-bttns">
          <RegularButton
            textIntlId="contactProfile.manualInput"
            defaultMessage="I will contact directly"
            variant="secondary"
            onClick={() => review(SurveyStatus.ManualInput)}
          />
          <RegularButton
            textIntlId="contactProfile.automate"
            defaultMessage="Automate / send survey"
            variant="primary"
            onClick={() => review(SurveyStatus.Requested)}
          />
        </div>
      </div>
    </ModalWindow>
  );
};

const mapDispachToProps = {
  updateRefStatus: updateRefStatusRoutine
};

export default connect(null, mapDispachToProps)(ReviewReferencesModal);
